var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3021_55646)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3021_55646",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 180,
    height: 180
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 90,
    fill: "url(#paint0_linear_3021_55646)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3021_55646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.609 66.5217C422.609 140.082 273.693 199.714 89.9962 199.714C-93.7006 199.714 -242.616 140.082 -242.616 66.5217C-242.616 -7.03845 -93.7006 -66.6708 89.9962 -66.6708C273.693 -66.6708 422.609 -7.03845 422.609 66.5217Z",
    fill: "url(#paint1_radial_3021_55646)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.997 93.1322C106.854 93.1322 120.519 79.4672 120.519 62.6105C120.519 45.7538 106.854 32.0887 89.997 32.0887C73.1403 32.0887 59.4752 45.7538 59.4752 62.6105C59.4752 79.4672 73.1403 93.1322 89.997 93.1322ZM152.383 180V150.241C152.383 122.849 124.454 100.643 90.0018 100.643C55.5496 100.643 27.6206 122.849 27.6206 150.241L27.6326 180H152.383Z",
    fill: "url(#paint2_linear_3021_55646)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3021_55646",
    x1: 0,
    y1: 0,
    x2: 187.77,
    y2: 8.50704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#F7CFDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3021_55646",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(89.9962 66.5217) rotate(90) scale(117.209 182.937)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CFDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCA2F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3021_55646",
    x1: 99.7729,
    y1: 32.0887,
    x2: 27.6206,
    y2: 180.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261585,
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.919717,
    stopOpacity: 0.56
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3021_55646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/default-avatar.1f739cb335c60705c0e09d06a7e0e5e2.svg";
export { ForwardRef as ReactComponent };